import React from 'react'
import {
  fetchPageDataFailure,
  fetchPageDataSuccess,
} from 'client/actions/pageActions'
import { useWebsiteSettings } from 'client/store'
import { useActions } from 'common/hooks/useActions'
import { changeWebsitePageId } from 'common/utils/urlUtils'
import { useState } from 'react'
import { useRollbar } from '@rollbar/react'
import { fetchEditorPage } from 'client/api/pageApi'
import { AccessDenied } from 'common/errors/AccessDenied'
import { NetworkError, NotFound } from 'common/errors'
import { useTranslation } from 'react-i18next'
import { UnsavedPageModal } from 'src/editor/layout/sidebar/pages-management/components/unsaved-page-modal'
import { getWebsiteLayoutPageId } from 'src/editor/store/website-settings/website-settings-selector'
import { getUrlPathList } from 'common/utils/urlUtils'
import usePresentPage from 'client/hooks/usePresentPage'
import { selectors } from 'client/reducers/pageReducer'
import { useCurrentUrl } from 'src/editor/hooks/use-current-url'

export const useFetchAndSwitchPage = () => {
  const { t } = useTranslation()
  const rollbar = useRollbar()
  const [isLoading, setIsLoading] = useState(false)
  const [unsavedPageId, setUnsavedPageId] = useState<null | number>(null)
  const layoutPageId = useWebsiteSettings(getWebsiteLayoutPageId)
  const dispatchFetchPageDataFail = useActions(fetchPageDataFailure)
  const dispatchFetchPageData = useActions(fetchPageDataSuccess)

  const isPageModified = usePresentPage(selectors.isPageModified)

  const currentUrl = useCurrentUrl()
  const urlPageId = getUrlPathList(currentUrl)[3]

  const fetchPageData = async (pageId: number) => {
    changeWebsitePageId(pageId)
    setIsLoading(true)
    try {
      const mergedWebsitePage = await fetchEditorPage(pageId, layoutPageId)

      dispatchFetchPageData(mergedWebsitePage, rollbar)
      setIsLoading(false)
    } catch (error) {
      if (error instanceof AccessDenied) {
        // do nothing
      } else if (error instanceof NotFound) {
        dispatchFetchPageDataFail(t('core.errors.page_not_found'))
      } else if (error instanceof NetworkError) {
        dispatchFetchPageDataFail(t('core.errors.no_connection'))
      } else {
        dispatchFetchPageDataFail(t('core.errors.went_wrong_contact_support'))
      }
      setIsLoading(false)
    }
  }
  const checkPageModification = (pageId: number) => {
    if (isPageModified) {
      setUnsavedPageId(pageId)
    } else {
      fetchPageData(pageId)
    }
  }
  const renderUnsavedPageModal = () =>
    unsavedPageId && (
      <UnsavedPageModal
        isVisible={!!unsavedPageId}
        onClose={() => setUnsavedPageId(null)}
        fetchPageData={() => fetchPageData(unsavedPageId as number)}
      />
    )

  return {
    urlPageId,
    isLoading,
    fetchPageData,
    checkPageModification,
    renderUnsavedPageModal,
  }
}
